module.exports = __webpack_public_path__ + "images/speed-eight-active.a4a9b33d7fe159a1d4b92f813811d532.png";